const modalVideo = () => {
    const video = document.querySelectorAll('[data-modal-open="modalVideo"]');
    const closeVideo = document.querySelectorAll('[data-modal-close="modalVideo"]');


    video.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const videoSrc = button.dataset.src;

            const container     = document.querySelector('[data-modal="video"]');
            container.innerHTML = '';

            const video    = document.createElement('video');
            video.src      = videoSrc;
            video.controls = true;
            video.autoplay = true;

            container.appendChild(video);
        });
    });

    closeVideo.forEach(item => {
        item.addEventListener('click', (event) => {
            const container     = document.querySelector('[data-modal="video"]');
            container.innerHTML = '';
        });
    })

    const itemVideo = document.querySelectorAll('[data-iframe]');
    const resetUrl = document.querySelectorAll('[data-modal-close="modalIframe"]');
    const wrapperIframe = document.querySelector('[data-wrapper-iframe]');

    itemVideo.forEach((item) => {
        item.addEventListener('click', () => {
            const url = item.dataset.iframe;
            const iframe = document.createElement("iframe");
            wrapperIframe.append(iframe);
            iframe.setAttribute('src', url);
        });

    });

    resetUrl.forEach((item) => {
        item.addEventListener('click', () => {
            wrapperIframe.querySelector('iframe').remove();
        });
    });

};

export default modalVideo;
